import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelect from '@nxsys/components/AppSelect';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Option } from '@nxsys/types/models/Common';
import moment from 'moment';
import React, { useState } from 'react';

type IssuedP45 = {
  url?: string;
  data?: {
    dateLeft?: string;
  };
};

type ModalReP45Props = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: { dateLeft: string }) => void;
  dataIssuedP45: IssuedP45[];
  action?: 'DOWNLOAD' | 'SENDMAIL';
};

const ModalReP45: React.FC<ModalReP45Props> = ({
  isOpen,
  toggle,
  onSubmit,
  dataIssuedP45 = [],
  action = 'DOWNLOAD',
}) => {
  const { messages } = useTypedIntl();
  const [selected, setSelected] = useState<Option<string> | null>(null);

  const p45Options = dataIssuedP45.map((item) => ({
    value: item.data?.dateLeft ?? '',
    label: moment(item.data?.dateLeft).format('DD/MM/YYYY'),
  }));

  const handleSubmit = () => {
    if (!selected) return;
    onSubmit({ dateLeft: selected.value });
    setSelected(null);
  };

  return (
    <AppModalContainer
      title={
        action === 'SENDMAIL'
          ? messages['common.sendP45'] ?? 'Send P45'
          : messages['common.downloadP45'] ?? 'Download P45'
      }
      isOpen={isOpen}
      toggle={() => {
        setSelected(null);
        toggle();
      }}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: () => {
            setSelected(null);
            toggle();
          },
        },
        {
          name:
            action === 'SENDMAIL'
              ? messages['common.send'] ?? 'Send'
              : messages['common.download'] ?? 'Download',
          buttonType: 'primary',
          onClick: handleSubmit,
          disabled: !selected,
        },
      ]}
      minHeight="150px"
    >
      <AppSelect
        options={p45Options}
        value={selected}
        onChange={(val: Option<string>) => setSelected(val)}
        placeholder={messages['common.dateLeft'] ?? 'Date Left'}
        className="w-full !min-w-0"
      />
    </AppModalContainer>
  );
};

export default ModalReP45;
